//250328 order (기존 Submit과 분리, 샵개발과 함께 진행)
import axios from 'axios'
import API from '@/common/api'
import store from '..'
import { updateOffsetFromResponse } from '@/common/responseOffset'

export default {
  namespaced: true,
  state: {
  },
  mutations: {
  },
  actions: {
    // 새로운 오더(setSubmit)
    async setSubmit ({ state }, d) {
      const userInfo = store.getters['guest/getGuestUserInfo']
      const siteInfo = store.state.authentication
      const siteid = siteInfo.site
      const spaceid = siteInfo.space
      const ota = siteInfo && siteInfo.k
      const gpId = siteInfo && siteInfo.gpId
      const data = d.data
      const orderUserInfo = d.orderUserInfo
      try {
        // 나중에 수정하게 되면 collection/addCollection도 동일한 api 사용하고 있으니 같이 수정해야함
        const res = await axios.post(`${API.ORDER_URL}/v1/api/order/${siteid}/${spaceid}`, {
          cmd: 'sc-service',
          func: 'set-submit',
          // pageId: data.pageId,
          catCode: data.catCode,
          userInfo: {
            ...userInfo && userInfo.rid && {
              rid: userInfo.rid
            },
            ...userInfo && userInfo.stayAfter && {
              stayAfter: userInfo.stayAfter
            },
            ...userInfo && userInfo.stayBefore && {
              stayBefore: userInfo.stayBefore
            },
            ...ota && {
              ota: ota
            },
            ...orderUserInfo && { // 커스텀 주문자 정보 입력필드 arr
              others: orderUserInfo
            }
          },
          ...gpId && {
            gpId: gpId
          },
          payload: data.payload
        })
        return res.data
      } catch (ex) {
        // console.log(ex)
        return ex && ex.response
      }
    },
    // shop billing 마감 여부 체크 (pos연동시)
    async checkOrderStatus ({ state }, pageId) {
      const siteInfo = store.state.authentication
      const siteid = siteInfo.site
      const spaceid = siteInfo.space
      const ota = siteInfo && siteInfo.k
      try {
        const res = await axios.post(`${API.ORDER_URL}/v1/api/order/${siteid}/${spaceid}`, {
          cmd: 'sc-service',
          func: 'check-order-status',
          pageId: pageId,
          ota: ota
        })
        return res.data
      } catch (ex) {
        // console.log(ex)
        return ex && ex.response
      }
    },
    // shop list 진입 전 인원 정보 호출(설정값은 shop property에 있음)
    async getShopGuestInfo ({ state, commit }, catCode) {
      const siteInfo = store.state.authentication
      const siteid = siteInfo.site
      const spaceid = siteInfo.space
      const ota = siteInfo && siteInfo.k
      if (!ota) return false
      try {
        const res = await axios.get(`${API.ORDER_URL}/v1/api/order/shop/guest?siteid=${siteid}&spaceid=${spaceid}&ota=${ota}&catCode=${catCode}`)
        const shopGuest = (res && res.data && res.data.status === 200 && res.data.result) || null
        store.commit('shop/setShopGuest', shopGuest)
        return res && res.data && res.data.result
      } catch (ex) {
        // console.log(ex)
        return ex && ex.response
      }
    },
    // shop list 진입 전 인원 정보 등록
    async setShopGuestInfo ({ state }, data) {
      const siteInfo = store.state.authentication
      const siteid = siteInfo.site
      const spaceid = siteInfo.space
      const ota = siteInfo && siteInfo.k
      try {
        const res = await axios.put(`${API.ORDER_URL}/v1/api/order/shop/guest`, {
          pageId: data.pageId,
          siteid: siteid,
          spaceid: spaceid,
          ota: ota,
          guestInfos: data.guestInfos
        })
        return res.data
      } catch (ex) {
        // console.log(ex)
        return ex && ex.response
      }
    },
    // shop의 billingNo별 category아이템 order count와 shopItemId별 order count
    async getBillingInfo ({ state, commit }, catCode) {
      const siteInfo = store.state.authentication
      const siteid = siteInfo.site
      const spaceid = siteInfo.space
      const ota = siteInfo && siteInfo.k
      if (!ota) return false
      try {
        const res = await axios.get(`${API.ORDER_URL}/v1/api/order/shop/billing?siteid=${siteid}&ota=${ota}&catCode=${catCode}`, {
          meta: { syncTime: true }
        })
        const billingInfo = (res && res.data && res.data.status === 200 && res.data.billingInfo) || null
        if (res && res.config && res.config.meta && res.config.meta.syncTime) {
          updateOffsetFromResponse(res)
        }
        return billingInfo
      } catch (ex) {
        // console.log(ex)
        return ex && ex.response
      }
    },
  },
  getters: {
  }
}
